import React from "react"
import BottomBar from "../BottomBar/bottombar"
import { useHistory } from "react-router"
import { useEffect } from "react"
import { useSelector } from "react-redux"
import { RootState } from "store/store"
import { Timeout } from "../../images"
import { login } from "../../images"
import "./SessionTimeOut.css"
import { useTranslation } from "react-i18next"

export default function SessionTimeOut() {
  const { t } = useTranslation()
  const facilityCode = useSelector(
    (state: RootState) => state.locationReducer.facilityCode
  )
  const history: any = useHistory()
  const initiateLogin = () => {
    window.location.href = window.location.origin + facilityCode
  }

  let timer1 = setTimeout(() => {
    window.location.href = window.location.origin + facilityCode
  }, 10000)

  useEffect(() => {
    return () => {
      clearTimeout(timer1)
    }
    //eslint-disable-next-line
  }, [])

  return (
    <div className="container">
      <img className="sessiontimeout" src={Timeout} alt="alert-icon" />
      <div className="sessiontimeout-text">{t("session_timed_out")}</div>
      <div className="sessiontimeout-instructions">
        {t("please_login_again_to_continue")}
        <br />
        {t("progress_has_been_saved_text")}
      </div>
      <BottomBar
        onClick={() => {
          initiateLogin()
        }}
        text={t("login")}
        startIcon={<img src={login} alt="login" />}
      />
    </div>
  )
}
